import { Levels } from 'enums';

import type { UsefulLink } from './types';

export const usefulLinks: { [key in Levels]: UsefulLink[] } = {
  [Levels.One]: [
    {
      title: 'Employee mental health: What are the risks for remote workers?',
      description: `Long hours online and isolation has impacted mental health.`,
      link: 'https://www.oysterhr.com/library/employee-mental-health-what-are-the-risks-for-remote-workers',
    },
    {
      title: 'The key to managing across cultures in 2022 and beyond',
      description: 'We look at the challenges and how to overcome them.',
      link: 'https://www.oysterhr.com/library/the-key-to-managing-across-cultures-in-2022-and-beyond',
    },
    {
      title:
        'People are people first: Fostering an inclusive workplace for all',
      description: `In celebration of Pride Month, let's talk about diversity.`,
      link: 'https://www.oysterhr.com/library/fostering-an-inclusive-workplace',
    },
    {
      title: 'Hire globally',
      description: `Whether you’re hiring employees in Spain or Singapore, we’ve got you covered. Learn best practices for building your global workforce with Oyster’s global hiring guides.`,
      link: 'https://www.oysterhr.com/global-hiring-guides',
    },
  ],
  [Levels.Two]: [
    {
      title:
        'People are people first: Fostering an inclusive workplace for all',
      description: `In celebration of Pride Month, let's talk about diversity.`,
      link: 'https://www.oysterhr.com/library/fostering-an-inclusive-workplace',
    },
    {
      title: 'How to attract, hire, and retain top talent at tech companies',
      description:
        'Skilled workers everywhere are realizing that they can work from anywhere—and earn more competitive wages in other markets while doing so. In this guide, we explore the most common issues companies face when hiring tech talent in the new world of work, as well as what top tech talent really wants from a job.',
      link: 'https://www.oysterhr.com/tech-talent-guide',
    },
    {
      title: 'Global Employment Cost Calculator',
      description: `Instantly calculate your total cost of employment based on your team members' country of residence: including taxes, contributions, and the Oyster flat-fee.`,
      link: 'https://www.oysterhr.com/employee-cost-calculator',
    },
    {
      title: 'Hire globally',
      description: `Whether you’re hiring employees in Spain or Singapore, we’ve got you covered. Learn best practices for building your global workforce with Oyster’s global hiring guides.`,
      link: 'https://www.oysterhr.com/global-hiring-guides',
    },
  ],
  [Levels.Three]: [
    {
      title: 'Engagement and Culture',
      description: `Advice, tips, and how to's on employee engagement and creating a great distributed culture.`,
      link: 'https://www.oysterhr.com/category/engagement-and-culture',
    },
    {
      title: 'Managing Distributed Teams',
      description:
        'Learn how to manage your team wherever they work in the world.',
      link: 'https://www.oysterhr.com/category/managing-distributed-teams',
    },
    {
      title: 'Hire globally',
      description: `Whether you’re hiring employees in Spain or Singapore, we’ve got you covered. Learn best practices for building your global workforce with Oyster’s global hiring guides.`,
      link: 'https://www.oysterhr.com/global-hiring-guides',
    },
    {
      title: 'How to attract, hire, and retain top talent at tech companies',
      description:
        'Skilled workers everywhere are realizing that they can work from anywhere—and earn more competitive wages in other markets while doing so. In this guide, we explore the most common issues companies face when hiring tech talent in the new world of work, as well as what top tech talent really wants from a job.',
      link: 'https://www.oysterhr.com/tech-talent-guide',
    },
  ],
  [Levels.Four]: [
    {
      title: 'Remote Work',
      description: 'Thought leadership and practical tips on working remotely.',
      link: 'https://www.oysterhr.com/category/remote-work',
    },
    {
      title: 'Engagement and Culture',
      description: `Advice, tips, and how to's on employee engagement and creating a great distributed culture.`,
      link: 'https://www.oysterhr.com/category/engagement-and-culture',
    },
    {
      title: 'Preparing for Distributed Work',
      description:
        'Your starting point for building skills for distributed work.',
      link: 'https://www.oysterhr.com/distributed-work',
    },
  ],
  [Levels.Five]: [
    {
      title: 'Preparing for Distributed Work',
      description:
        'Your starting point for building skills for distributed work.',
      link: 'https://www.oysterhr.com/distributed-work',
    },
    {
      title:
        'Remote vs. distributed: What the differences are and why distributed is the future of work',
      description: 'Distributed work is here to stay. Is your HR team ready?',
      link: 'https://www.oysterhr.com/library/remote-vs-distributed',
    },
    {
      title: 'Why the renaissance of HR begins today',
      description: 'The HR industry is at a crucial turning point.',
      link: 'https://www.oysterhr.com/library/why-the-renaissance-of-hr-begins-today',
    },
    {
      title:
        '3 key reasons why your remote work strategy failed (and what to do about it)',
      description: `There's no one-size-fits-all remote work strategy.`,
      link: 'https://www.oysterhr.com/library/3-key-reasons-why-your-remote-work-strategy-failed-and-what-to-do-about-it',
    },
  ],
  [Levels.Six]: [],
};
